// extracted by mini-css-extract-plugin
module.exports = {"price":"Price-module--price--3A1Tw","active":"Price-module--active--1p4bI"};